/**
 * Moderation action types and their display labels.
 * This is the single source of truth for all moderation actions.
 */
export const ModerationActions = {
  // User actions
  ban_user: "Banned user",
  unban_user: "Unbanned user",

  // Comment actions (by moderators)
  hide_comment: "Hid comment",
  unhide_comment: "Restored comment",

  // Comment actions (by the comment author)
  user_hide_comment: "User deleted own comment",
  user_unhide_comment: "User restored own comment",

  // Review actions
  hide_review: "Hid review",
  unhide_review: "Restored review",

  // Entry actions
  hide_entry: "Hid entry",
  unhide_entry: "Restored entry",

  // Vote actions
  ignore_vote: "Ignored vote",
  unignore_vote: "Restored vote",
  ignore_all_user_votes: "Ignored all votes from user",
  unignore_all_user_votes: "Restored all votes from user",
} as const;

export type ModerationActionType = keyof typeof ModerationActions;

/**
 * Target types for moderation actions
 */
export const ModerationTargets = {
  user: "user",
  comment: "comment",
  review: "review",
  entry: "entry",
  vote: "vote",
} as const;

export type ModerationTargetType = keyof typeof ModerationTargets;

/**
 * Get the display label for a moderation action
 */
export function getModerationActionLabel(action: ModerationActionType): string {
  return ModerationActions[action];
}
